import { MerchantUserDto } from "@/models/club";
import { useGetImage } from "@/utilities/helper/getImage";
import { Avatar, Checkbox, Group, Text } from "@mantine/core";

type Props = {
  user: MerchantUserDto;
};

function UserFilterItem({ user }: Props) {
  const { imageUrl } = useGetImage({ image: user?.image });
  return (
    <Checkbox.Card
      radius="md"
      value={user?.id?.toString()}
      key={user?.id?.toString()}
      withBorder={false}
    >
      <Group wrap="nowrap" align="center">
        <Checkbox.Indicator />
        <Group>
          <Avatar
            variant="outline"
            color="blue"
            radius="xl"
            size="md"
            src={imageUrl}
            p="3"
            styles={{
              image: {
                borderRadius: "100px",
              },
              root: {
                border: `2px solid ${user?.calendarColor}`,
              },
            }}
          >
            {user?.firstName?.charAt(0) || ""}
          </Avatar>
          <Text>
            {user?.firstName} {user?.lastName}
          </Text>
        </Group>
      </Group>
    </Checkbox.Card>
  );
}

export default UserFilterItem;
